import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  type CarrierLogisticsCredType,
  carrierLogistics,
} from '../standards.js'

export type ttfyCredType = CarrierLogisticsCredType
export const ttfyDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const ttfy: CarrierDef<ttfyCredType> = {
  name: 'Titan Freight Systems',
  scac: 'ttfy',
  ...carrierLogistics,
  engineLayers: ['documents', 'rating', 'pickup', 'tracking', 'profinder'],
  documentTypes: ttfyDocumentTypes,
}
